import { VBadge } from 'vuetify/lib/components/VBadge';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VBadge,
    {
      attrs: {
        color: _vm.color,
        left: _vm.left,
        bottom: _vm.bottom,
        overlap: _vm.overlap,
      },
      scopedSlots: _vm._u(
        [
          {
            key: "badge",
            fn: function () {
              return [_vm._t("badge-content")]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
    },
    [_vm._v(" "), _vm._t("badge-anchor")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }